import React from 'react';
import PropTypes from 'prop-types';

import { Root, Header, LogoContainer, Content } from './ProgramFocusCard.style';

export const ProgramFocusCard = ({ title, desc }) => {
  return (
    <Root>
      <Header>
        <span>{title}</span>
        <LogoContainer />
      </Header>
      <Content>{desc}</Content>
    </Root>
  );
};

ProgramFocusCard.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};
